import React, { createContext, useContext, useEffect, useState } from "react";

export const SPORTS = [
  { key: "foot", label: "Football", color: "#00E676", active: true },
  { key: "tennis", label: "Tennis", color: "#FFD23F", active: true },
  { key: "basket", label: "Basket", color: "#FF7A1A", active: true },
];

const SportContext = createContext(null);
export const useSport = () => useContext(SportContext);

export function SportProvider({ children }) {
  const [sport, setSportState] = useState(() => localStorage.getItem("hitmax_sport") || "foot");
  const setSport = (s) => {
    setSportState(s);
    localStorage.setItem("hitmax_sport", s);
    localStorage.setItem("hitmax_sport_touched", "1");
  };
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--sport-accent",
      (SPORTS.find((s) => s.key === sport) || SPORTS[0]).color
    );
  }, [sport]);
  const meta = SPORTS.find((s) => s.key === sport) || SPORTS[0];
  return (
    <SportContext.Provider value={{ sport, setSport, meta, SPORTS }}>
      {children}
    </SportContext.Provider>
  );
}
